module.exports = __webpack_public_path__ + "static/media/mautic_logo.76c4d924.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mautic_logo.png
// module id = 2180
// module chunks = 0